module.exports = __webpack_public_path__ + "static/media/mercy_adetunji.6e983e05.png";